// NewButton.jsx
import React from 'react';
import './NewButton.css';
import '../../common/CommonText.css'
import { useTranslation } from 'react-i18next';

const NewButton = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <button 
      className='new-yellow-button common-text ftw-4'
      onClick={onClick} 
      style={{ cursor: "pointer" }}
    >
      + {t("New")}
    </button>
  );
};

export default NewButton;
